import { useMutation } from "@tanstack/react-query";
import { useCallback } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { AttachTagsToMiners } from "../../api/api";

type SiteResult = {
  status: string;
  Msg?: string;
  errorCode?: string;
};

type AttachTagsPayload = {
  minernames: string[];
  tags: string[];
};

export const usePostAttachTagsToMiners = () => {
  const { getAccessTokenSilently } = useAuth0();

  const mutation = useMutation({
    mutationFn: ({
      minernames,
      tags,
      token,
    }: AttachTagsPayload & {
      token: string;
    }): Promise<SiteResult> =>
      AttachTagsToMiners({ minernames, tags }, token),

    onSuccess: (data) => {},

    onError: (error) => {},
  });

  const mutateWithToken = useCallback(
    async (
      { tags, minernames }: AttachTagsPayload,
      options?: {
        onSuccess?: (data: SiteResult) => void;
        onError?: (error: unknown) => void;
        onSettled?: () => void;
      }
    ) => {
      const token = await getAccessTokenSilently();

      return mutation.mutateAsync(
        {
          tags,
          minernames,
          token,
        },
        {
          onSuccess: options?.onSuccess,
          onError: options?.onError,
          onSettled: options?.onSettled,
        }
      );
    },
    [getAccessTokenSilently, mutation]
  );

  return { ...mutation, mutate: mutateWithToken };
};
